import { Select } from "@cofano/cck";
import { DataFormat } from "utils";
import { Session } from "ezStore";
import { StatusChangeFragmentFragment as StatusChangeFragment } from "__generated__/view/statuses/graphql/fragments.generated";

type StatusChangeSelectProps = {
	value?: StatusChangeFragment;
	onChange: (value?: StatusChangeFragment | null) => void;
	statusChanges: StatusChangeFragment[];
	session: Session;
}

const StatusChangeSelect = ({ value, onChange, statusChanges, session }: StatusChangeSelectProps) => {
	return <Select
		value={value}
		onChange={onChange}
		fetchOptions={statusChanges}
		clearable={false}
		getOptionLabel={statusChange => DataFormat.status(statusChange.status, session.user?.language ?? undefined)}
		getOptionColor={statusChange => statusChange.status.color}
		disableSearch={true} />;
};

export default StatusChangeSelect;
